<template>
    <div class="nutrition">
        <div style="color: red">
            请核对信息与「对应识别图片」中包含信息一致，此模块信息直接在前端展示给用户
        </div>
        <div>
            营养成分表国家标准示例
            <mc-link path="https://p0.meituan.net/mallimages/9b653d673b818bb5af9c38558cb1d532178141.png">
                查看示例
            </mc-link>
        </div>

        <mc-loading
            v-if="loading"
            style="width:500px"
        />

        <div v-else>
            <div
                v-for="(innerItem,innerIndex) in innerValue"
                :key="innerItem.uuId"
                class="nutrition-facts"
            >
                <div class="nutrition-facts-item">
                    <mc-configform
                        ref="configForm"
                        v-model="innerValue[innerIndex]"
                        :fields="nutritionFactsFields"
                        :disabled="disabled"
                    >
                        <template slot="nutritions">
                            <div
                                v-if="innerItem.nutritions && innerItem.nutritions.headers"
                                class="nutritions-items"
                            >
                                <div
                                    v-for="(headersItem,headersIndex) in innerItem.nutritions.headers"
                                    :key="headersIndex"
                                    class="item"
                                >
                                    <div
                                        v-if="!headersIndex"
                                        class="item"
                                    >
                                        项目
                                    </div>
                                    <mc-input
                                        v-else
                                        v-model="innerItem.nutritions.headers[headersIndex]"
                                        class="w-150"
                                    />
                                </div>
                            </div>

                            <div
                                v-for="(itemsItem,itemsIndex) in innerItem.nutritions.items"
                                :key="itemsItem.uuId"
                            >
                                <div class="nutritions-items mt-20">
                                    <span v-if="itemsItem.parentItem">——</span>
                                    <div
                                        v-for="(detailsItem,detailsIndex) in itemsItem.details"
                                        :key="detailsIndex"
                                        class="item"
                                    >
                                        <mc-input
                                            v-model="itemsItem.details[detailsIndex]"
                                            class="w-150"
                                            @change="(val)=>handleItemDetailChange(val,innerIndex,itemsIndex,detailsIndex)"
                                        />
                                    </div>

                                    <McOptionButtons
                                        :source="{innerIndex,itemsIndex}"
                                        :button-render="buttonRender"
                                    />
                                </div>

                                <div
                                    v-show="ingredient(itemsItem.parentItem,itemsItem.details[0])"
                                    style="padding-left:20px;color:red;margin-bottom: -20px"
                                >
                                    {{ ingredient(itemsItem.parentItem,itemsItem.details[0]) }}
                                </div>
                            </div>
                        </template>
                    </mc-configform>
                </div>

                <mc-button
                    type="primary"
                    :disabled="disabled"
                    @click="handleAddOrDelete(innerIndex)"
                >
                    {{ innerIndex ? '删除' : '新增' }}
                </mc-button>

                <div
                    v-if="usePicUrl && !innerIndex"
                    style="margin-left:20px; text-align: center;"
                >
                    <mc-image
                        style="width: 100px; height: 100px"
                        :src="usePicUrl"
                        :preview-url-list="[usePicUrl]"
                    />
                    <div>对应识别的图片</div>

                    <mc-button
                        v-if="!disabled"
                        type="primary"
                        @click="handleChangeIdentifyImg"
                    >
                        重新选择识别图片
                    </mc-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, getCurrentInstance, ref } from '@vue/composition-api';
import { cloneDeep, hPost } from '@mcfe/tools';
import { defaultNutritions, defaultNutritionsItems } from './config';

const nutritionFactsFields = Object.freeze([
    {
        label: '子商品名称',
        prop: 'productName',
    },
    {
        label: '营养成分表',
        slot: 'nutritions',
    },
]);

export default {
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        usePicUrl: {
            type: String,
            default: '',
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance();

        const innerValue = computed({
            get() {
                return props.value;
            },
            set(val) {
                proxy.$emit('input', val);
            },
        });

        const nutritionsFirstName = ref([]); // 营养成分表一级元素
        const nutritionsSecondName = ref([]); // 营养成分表二级元素

        // change的时候同步同步数组的第一项值parentItem 通过parentItem是否是二级元素
        const handleItemDetailChange = (val, innerIndex, itemsItem, detailsIndex) => {
            if (detailsIndex) return;
            innerValue.value[innerIndex].nutritions.items[itemsItem].itemName = val;
            if (innerValue.value[innerIndex].nutritions.items[itemsItem + 1] && innerValue.value[innerIndex].nutritions.items[itemsItem + 1].parentItem) {
                innerValue.value[innerIndex].nutritions.items[itemsItem + 1].parentItem = val;
            }
        };
        const ingredient = computed(() => (parentItem, item) => {
            if (parentItem && nutritionsFirstName.value.includes(item)) return '根据国家标准，系统建议调整为一级元素，实际请与实物图片保持一致';
            if (!parentItem && nutritionsSecondName.value.includes(item)) return '根据国家标准，系统建议调整为二级元素，实际请与实物图片保持一致';
            return '';
        });

        const buttonRender = ({ innerIndex, itemsIndex }) => {
            const nutritionsItems = innerValue.value[innerIndex].nutritions.items;
            return [{
                label: nutritionsItems[itemsIndex].parentItem ? '切换一级' : '切换二级',
                type: 'button',
                permission: !!itemsIndex && !props.disabled,
                clickFn: () => {
                    const currentItem = nutritionsItems[itemsIndex];
                    const previousItem = nutritionsItems[itemsIndex - 1];
                    if (!previousItem.itemName) {
                        proxy.$mc.message.error('上级名称必填');
                        return;
                    }
                    nutritionsItems[itemsIndex].parentItem = currentItem.parentItem ? '' : previousItem.parentItem || previousItem.itemName;
                },
            }, {
                label: itemsIndex ? '删除' : '新增',
                type: 'button',
                permission: !props.disabled,
                clickFn: () => {
                    if (!itemsIndex) {
                        nutritionsItems.push(defaultNutritionsItems());
                        return;
                    }
                    nutritionsItems.splice(itemsIndex, 1);
                },
            }, {
                label: '上移',
                type: 'button',
                permission: !!itemsIndex && !props.disabled,
                clickFn: () => {
                    if (itemsIndex === 1 && nutritionsItems[itemsIndex].parentItem) {
                        proxy.$mc.message.error('二级成分不能成为第一项');
                        return;
                    }
                    const item = cloneDeep(nutritionsItems[itemsIndex]);
                    nutritionsItems.splice(itemsIndex, 1);
                    nutritionsItems.splice(itemsIndex - 1, 0, item);
                },
            }, {
                label: '下移',
                type: 'button',
                permission: nutritionsItems.length - 1 !== itemsIndex && !props.disabled,
                clickFn: () => {
                    const item = cloneDeep(nutritionsItems[itemsIndex]);
                    nutritionsItems.splice(itemsIndex, 1);
                    nutritionsItems.splice(itemsIndex + 1, 0, item);
                },
            }];
        };

        const handleAddOrDelete = (innerIndex) => {
            if (!innerIndex) {
                innerValue.value.push(defaultNutritions());
                return;
            }
            innerValue.value.splice(innerIndex, 1);
        };

        // 获取配置的一级二级元素
        const getNutritionsName = async () => {
            const res = await hPost('/api/m/tms/mapi/dictionary/batchGetDictionaryAndValue', {
                dicCodes: ['special:product:nutritions_second_name', 'special:product:nutritions_first_name'],
            });
            nutritionsFirstName.value = (res['special:product:nutritions_first_name']?.dictionaryValueList || []).map((item) => item.name);
            nutritionsSecondName.value = (res['special:product:nutritions_second_name']?.dictionaryValueList || []).map((item) => item.name);
        };

        // 重新选择识别图片
        const handleChangeIdentifyImg = () => {
            proxy.$emit('changeIdentifyImg', 'nutritions');
        };

        getNutritionsName();

        return {
            nutritionFactsFields,

            innerValue,
            nutritionsFirstName,
            nutritionsSecondName,
            handleItemDetailChange,
            buttonRender,
            handleAddOrDelete,
            ingredient,
            handleChangeIdentifyImg,
        };
    },

};
</script>

<style lang="scss" scoped>
.nutrition {
    .nutrition-facts {
        display: flex;
        align-items: center;
        width: 1150px;
        margin-bottom: 20px;
        .nutrition-facts-item {
            padding: 20px 20px 0 10px;
            border-radius: 10px;
            border: 1px solid #e0e0e0;
            margin-right: 30px;
            .nutritions-items {
                display: flex;
                .item {
                    width: 170px;
                    text-align: center;
                    padding: 0 10px;
                }
            }
            .mt-20 {
                margin-top: 20px;
            }
        }
    }
    .nutrition-facts:last-child {
        margin-bottom: 0px;
    }
    .w-150 {
        ::v-deep .mtd-input-wrapper{
            width: 150px;
            text-align: center;
        }
    }
}

</style>
